import axios from 'axios';

// API Base URL from environment
const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API Functions
export const subscriptionApi = {
  /**
   * Get all available subscription plans
   */
  getPlans: async () => {
    const response = await api.get('/plans');
    return response.data.plans || response.data;
  },

  /**
   * Get user's current subscription status
   */
  getStatus: async (userId) => {
    const response = await api.get(`/subscription/status?user_id=${userId}`);
    return response.data;
  },

  /**
   * Validate a voucher code
   */
  validateVoucher: async (code, userId) => {
    const response = await api.post('/vouchers/validate', {
      code,
      user_id: userId,
    });
    return response.data;
  },

  /**
   * Activate voucher for a new user (creates account)
   */
  activateVoucherNewUser: async (code, user, consent) => {
    const response = await api.post('/vouchers/activate', {
      code,
      user,
      consent,
    });
    return response.data;
  },

  /**
   * Activate voucher for existing user
   */
  activateVoucherExisting: async (code, userId) => {
    const response = await api.post('/vouchers/activate-existing', {
      code,
      user_id: userId,
    });
    return response.data;
  },

  /**
   * Create a Razorpay subscription
   */
  createSubscription: async (userId, planId) => {
    const response = await api.post('/subscription/create', {
      user_id: userId,
      plan_id: planId,
    });
    return response.data;
  },

  /**
   * Confirm subscription after Razorpay payment
   */
  confirmSubscription: async (razorpayPaymentId, razorpaySubscriptionId, razorpaySignature) => {
    const response = await api.post('/subscription/confirm', {
      razorpay_payment_id: razorpayPaymentId,
      razorpay_subscription_id: razorpaySubscriptionId,
      razorpay_signature: razorpaySignature,
    });
    return response.data;
  },

  /**
   * Cancel subscription
   */
  cancelSubscription: async (userId, reason, cancelAtPeriodEnd = true) => {
    const response = await api.post(`/subscription/cancel?user_id=${userId}`, {
      reason,
      cancel_at_period_end: cancelAtPeriodEnd,
    });
    return response.data;
  },
};

export default subscriptionApi;
